import { Box, Dialog, styled } from '@mui/material';

export const getTitleSx = () => ({
  fontSize: '1.375rem',
  fontWeight: 500,
  color: '#010203',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontStyle: 'normal',
  lineHeight: '120%',
  textAlign: 'center' as const,
  alignSelf: 'stretch',
});

export const getSubtitleSx = (theme: any) => ({
  fontSize: '0.75rem',
  color: theme.palette.grey[800],
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  textAlign: 'center' as const,
});

export const getTextAreaSx = (theme: any, confirmButtonVariant: string) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: confirmButtonVariant === 'error' ? '0.75rem' : undefined,
    backgroundColor: confirmButtonVariant === 'error' ? theme.palette.error.light : undefined,
    border:
      confirmButtonVariant === 'error' ? `0.5px solid ${theme.palette.error.main}` : undefined,
    '& fieldset': {
      borderColor: confirmButtonVariant === 'error' ? 'transparent' : undefined,
    },
    '&:hover fieldset': {
      borderColor: confirmButtonVariant === 'error' ? 'transparent' : undefined,
    },
    '&.Mui-focused fieldset': {
      borderColor: confirmButtonVariant === 'error' ? 'transparent' : undefined,
    },
  },
  '& .MuiOutlinedInput-input': {
    color: theme.palette.grey[800],
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '160%',
    textAlign: 'left',
    '::placeholder': {
      color: theme.palette.grey[800],
      opacity: 1,
    },
  },
});

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '24px',
    boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.15)',
    width: '25rem',
  },
}));

export const DialogContentWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  alignItems: 'center',
  // padding: '32px',
  textAlign: 'center',
}));

export const IconContainer = styled(Box)<{ bgColor: string }>(({ bgColor }) => ({
  width: '75px',
  height: '75px',
  borderRadius: '50%',
  backgroundColor: bgColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  alignSelf: 'stretch',
}));
